// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__32we_","name":"ConsentHeader_name__1dmYt","birthday":"ConsentHeader_birthday__2Usqs","skeleton":"ConsentHeader_skeleton__3RBqK"};